import useSWR from 'swr';
import { EngineService } from '@/services/engine';

interface CameraValidationResult {
    live: boolean;
    errorType?: string;
    lastCheckedAt: Date;
    isRefreshing?: boolean;
}

export function useCameraValidation(sourceId: string) {
    const { data, isLoading, isValidating, mutate } =
        useSWR<CameraValidationResult>(
            sourceId ? ['camera-validation', sourceId] : null,
            async () => {
                const [result] = await Promise.all([
                    EngineService.validateCameraBySourceId(sourceId),
                ]);
                return {
                    live: result.isValid,
                    errorType: result.isValid ? undefined : result.errorType,
                    lastCheckedAt: new Date(),
                };
            },
            {
                revalidateOnFocus: false,
                revalidateIfStale: false,
            },
        );

    return {
        live: data?.live,
        errorType: data?.errorType,
        lastCheckedAt: data?.lastCheckedAt,
        isLoading: isLoading || isValidating || data?.isRefreshing,
        refetch: mutate,
    };
}
